export default "__VITE_ASSET__USLzTodU__"